import TruckColorIcon from '../components/common/icons/color/icr_envio.svg';
import BuildColorIcon from '../components/common/icons/color/icr_Armado.svg';
import ProductColorIcon from '../components/common/icons/color/icr_Preparando_pedido.svg';
import CancelColorIcon from '../components/common/icons/color/icr_terminos_condiciones.svg';
import RipleyCardIcon from '../components/common/icons/color/icr_TR.svg';
import RipleyComIcon from '../components/common/icons/color/icr_ripleycom.svg';
import GitfCardIcon from '../components/common/icons/color/icr_giftcard.svg';
import ArcoLawIcon from '../components/common/icons/color/icr_notificaciones.svg';

import {
  INVOICE_COPY,
  PROBLEM_IN_PURCHASE,
  PAGE_ERROR,
  EXTEND_VALIDITY,
  REMOVE_CLIENT_DATA,
  ARCO_LAW_INFO,
} from './routes';

export const ISSUES = [
  {
    icon: TruckColorIcon,
    title: 'Despacho y retiro',
    subtitle: 'Si tienes dudas sobre el despacho de tus compras, consúltanos.',
    disabled: false,
    id: '1',
    motives: [
      {
        id: '2',
        title: 'No ha llegado mi producto',
        issueFormName: 'NotReceived',
      },
      {
        id: '28',
        title: 'Autorizar a un tercero a retirar mi producto',
        issueFormName: 'AuthorizedThird',
      },
      {
        id: '10',
        title: 'Cambiar dirección de despacho',
        issueFormName: 'ChangeAddress',
      },
      {
        id: '1',
        title: 'Cambiar fecha de despacho',
        issueFormName: 'ChangeDate',
      },
      {
        id: '29',
        title: 'Cobro despacho Gold/Silver',
        issueFormName: 'GoldSilverDispatchCharge',
      },
    ],
  },
  {
    icon: ProductColorIcon,
    title: 'Productos',
    subtitle:
      'Si tienes inconvenientes con tu producto, déjanos tus datos y buscaremos la solución.',
    id: '2',
    disabled: false,
    motives: [
      {
        id: '6',
        title: 'Llegó en mal estado',
        issueFormName: 'BadState',
      },
      {
        id: '4',
        title: 'Llegó incompleto',
        issueFormName: 'Incomplete',
      },
      {
        id: '3',
        title: 'Llegó otro producto',
        issueFormName: 'OtherProduct',
      },
      {
        id: '5',
        title: 'No funciona',
        issueFormName: 'NotWorking',
      },
      {
        id: '37',
        title: 'Producto llegó con alarma',
        issueFormName: 'WithAlarm',
      },
    ],
  },
  {
    icon: CancelColorIcon,
    title: 'Anular Compra',
    subtitle:
      '¿Te arrepentiste de tu compra? Ingresa tus datos y nosotros gestionaremos tu anulación.',
    id: '3',
    disabled: false,
    motives: [
      {
        id: '7',
        title: 'Anular compra',
        issueFormName: 'CancelPurchase',
      },
      {
        id: '11',
        title: 'Ver estado de anulación de compra',
        issueFormName: 'StatusCancelPurchase',
      },
      {
        id: '44',
        title: 'Reversa fuera de plazo',
        issueFormName: 'ReverseOutOfTime',
      },
    ],
  },
  {
    icon: BuildColorIcon,
    title: 'Armar Producto',
    subtitle: 'Solicita el armado de tu compra y nos comunicaremos contigo.',
    id: '5',
    disabled: false,
    motives: [
      {
        id: '9',
        title: 'Armar Producto',
        issueFormName: 'AssembleProduct',
      },
    ],
  },
  {
    icon: RipleyCardIcon,
    title: 'Tarjeta Ripley',
    subtitle: 'Bloqueos, consulta puntos y mucho más.',
    id: '6',
    disabled: false,
    motives: [
      {
        id: '25',
        title: 'Bloqueo Tarjeta Ripley',
        alert: true,
      },
      {
        id: '12',
        title: 'Consultas Tarjeta Ripley',
        alert: true,
      },
      {
        id: '24',
        title: 'Pago de estado de cuenta',
        alert: true,
      },
      {
        id: '20',
        title: 'Ripley Puntos Go',
        alert: true,
      },
      {
        id: '23',
        title: 'Seguros Ripley',
        alert: true,
      },
    ],
  },
  {
    icon: RipleyComIcon,
    title: 'Compras en ripley.com',
    subtitle:
      'Cambia tu correo, clave y realiza otras solicitudes sobre Ripley.com',
    id: '7',
    disabled: false,
    motives: [
      {
        id: '27',
        title: 'Cambio de contraseña Ripley.com',
        issueFormName: 'ChangePassword',
      },
      {
        id: '26',
        title: 'Cambio de correo electrónico Ripley.com',
        issueFormName: 'ChangeEmail',
      },
      {
        id: '18',
        title: 'Copia de boleta o factura',
        alert: false,
        url: INVOICE_COPY,
        authorized: true,
      },
      {
        id: '17',
        title: 'Inconveniente al momento de comprar',
        alert: false,
        url: PROBLEM_IN_PURCHASE,
        authorized: true,
      },
      {
        id: '33',
        title: 'Error en la página',
        url: PAGE_ERROR,
        authorized: true,
      },
      {
        id: '43',
        title: 'No recibir publicidad de Ripley',
        url: REMOVE_CLIENT_DATA,
        issueFormName: 'RemoveClientData',
        authorized: true,
      },
    ],
  },
  {
    icon: GitfCardIcon,
    title: 'Gift Cards',
    subtitle:
      '¿Dudas sobre el saldo o extensión de vigencia de la gift card? Hazlo desde esta opción.',
    id: '9',
    disabled: false,
    motives: [
      {
        id: '22',
        title: 'Consulta de saldo Gift Card',
      },
      {
        id: '31',
        title: 'Extender vigencia Gift Card',
        type: 2,
        url: EXTEND_VALIDITY,
        issueFormName: 'ExtendValidity',
        authorized: true,
      },
      {
        id: '32',
        title: 'Extender vigencia Gift Card Empresa',
        alert: true,
      },
      {
        id: '36',
        title: 'Inconveniente con mi Gift Card',
        issueFormName: 'ProblemsGiftcard',
      },
    ],
  },
  {
    icon: ArcoLawIcon,
    title: 'Derechos ARCO',
    subtitle: 'Ejerce los derechos que te da la ley de datos personales.',
    id: '12',
    disabled: false,
    isNew: true,
    motives: [
      {
        id: '45',
        title: 'Ejercicios de derechos ARCO',
        url: ARCO_LAW_INFO,
        issueFormName: 'ArcoLaw',
        authorized: true,
      },
    ],
  },
];
